import { LitElement, html, css } from 'lit-element';
import { classMap } from 'lit-html/directives/class-map';
import { axios } from '@bundled-es-modules/axios';

class AccountDetailsComponent extends LitElement {

    static get properties() {
        return {
            _MainServiceDomain: { type: String },
            _loginDetails: { type: Object },
            _userDetails: { type: Object },
            _subscriptionDetails: { type: Object },
            _deliveryAddress: { type: Object },
            _edit: { type: Boolean, },
            _accountDetailsErrorResponse: { type: String },
            editPassword: { type: Boolean },
            editName: { type: Boolean },
            editPhoneNumber: { type: Boolean },
            isSystemError: { type: Boolean },
        }
    }

    get MainServiceDomain() {
        return this._MainServiceDomain;
    }

    set MainServiceDomain(value) {
        this._MainServiceDomain = value;
    }

    get edit() {
        return this._edit;
    }

    set edit(value) {
        this._edit = value;
    }

    get loginDetails() {
        return this._loginDetails;
    }

    set loginDetails(value) {
        this._loginDetails = value;
    }

    get userDetails() {
        return this._userDetails;
    }

    set userDetails(value) {
        this._userDetails = value;
    }

    get subscriptionDetails() {
        return this._subscriptionDetails;
    }

    set subscriptionDetails(value) {
        this._subscriptionDetails = value;
    }

    get deliveryAddress() {
        return this._deliveryAddress;
    }

    set deliveryAddress(value) {
        this._deliveryAddress = value;
    }

    get accountDetailsErrorResponse() {
        return this._accountDetailsErrorResponse;
    }

    set accountDetailsErrorResponse(value) {
        this._accountDetailsErrorResponse = value;
    }

    updated() {
        if (this.edit === false) {

            this.editName = false;
            this.editPhoneNumber = false;
            this.editPassword = false;
            this.isSystemError = false;

            this.accountDetailsErrorResponse = '';
        }

        if (this.shadowRoot.getElementById('updatePhoneNumber')) {
            this.shadowRoot.getElementById('updatePhoneNumber').addEventListener('keyup', function (e) {
                var match = e.target.value.replace(/\D/g, '').match(/^(\d{1,3})(\d{0,3})(\d{0,4})$/);
                if (match) {
                    e.target.value = `${match[1] ? '(' : ''}${match[1]}${match[2] ? ') ' : ''}${match[2]}${match[3] ? '-' : ''}${match[3]}`;
                }
            });
        }
    }

    constructor() {
        super();
        this.edit = false;
        this.editName = false;
        this.editPhoneNumber = false;
        this.editPassword = false;
        document.addEventListener('onSelectSubscription', async (e) => {
            this.loginDetails = e.detail.loginDetails;
            this.userDetails = e.detail.userDetails;
            this.subscriptionDetails = e.detail.selectedSubscription;
            this.deliveryAddress = await this.getSubscriberAddress();
        })
    }

    attributeChangedCallback(name, oldval, newval) {
        super.attributeChangedCallback(name, oldval, newval);
    }

    static get styles() {
        return css`
        * {
            margin: 0;
            padding: 0;
        }
        body {
            font-family: 'Open Sans', sans-serif;
        }
        .text-center {
            text-align: center;
        }
        
        .mg-b5 {
            margin-bottom: 5px;
        }
        
        .form-group {
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-flex: 0;
            -ms-flex: 0 0 auto;
            flex: 0 0 auto;
            -webkit-box-orient: horizontal;
            -webkit-box-direction: normal;
            -ms-flex-flow: row wrap;
            flex-flow: row wrap;
            -webkit-box-align: center;
            -ms-flex-align: center;
            align-items: center;
            margin-bottom: 0;
            color: var(--form-group-color, #fff);
        }
        
        .form-control {
            display: block;
            width: 100%;
            padding: 8px 12px;
            font-size: 14px;
            line-height: 1.5;
            color: var(--form-control-color, #000);
            background-color: var(--form-control-bgColor, #fff);
            background-clip: padding-box;
            border: 1px solid var(--form-control-borderColor, #000);
            border-radius: 4px;
        }
        
        .form-control:focus {
            color: var(--form-control-focus-color, #495057);
            background-color: var(--form-control-focus-bgColor, #fff);
            border-color: var(--form-control-borderColor, #80bdff);
            outline: 0;
            box-shadow: 0 0 0 0.2rem var(--form-control-focus-boxShadow, rgba(65, 157, 255, 0.25));
          }
        
          .form-control:hover {
            -webkit-appearance: none;
          }
        
        .form-control::-webkit-input-placeholder {
            color: var(--form-control-placehorderColor, #959595);
            opacity: 1;
        }
        
        .form-control::-moz-placeholder {
            color: var(--form-control-placeholderColor, #959595);
            opacity: 1;
        }
        
        .form-control:-ms-input-placeholder {
            color: var(--form-control-placeholderColor, #959595);
            opacity: 1;
        }
        
        .form-control::-ms-input-placeholder {
            color: var(--form-control-placeholderColor, #959595);
            opacity: 1;
        }
        
        .form-control::placeholder {
            color: var(--form-control-placeholderColor, #959595);
            opacity: 1;
        }
        
        .table {
            width: 100%;
            max-width: 100%;
            margin-bottom: 16px;
            border: none;
            border-collapse: collapse;
            border-spacing:0 15px;
            background-color: tranparent;
            border-collapse: separate;
        }
        
        .table th {
            padding: 5px;
            vertical-align: top;
            background-color: transparent;
            border: none;
            color: var(--w-txt-col, #434343);
            font-size: var(--w-txt-fs, 14px);
        }

        .table td {
            padding: 5px;
            vertical-align: top;
            background-color: var(--w-txt-bgc, #fff);
            border: none;
            color: var(--w-txt-col, #434343);
            font-size: var(--w-txt-fs, 14px);
        }
        
        .table-striped tbody tr:nth-of-type(even) {
            background-color: var(--background-color, #cdd4e8);
        }
        
        .table-striped tbody tr:nth-of-type(odd) {
            background-color: var(--background-color, #e7eaf4);
        }
        
        .btn {
            display: inline-block;
            font-weight: 400;
            text-align: center;
            white-space: nowrap;
            vertical-align: middle;
            -webkit-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
            user-select: none;
            border: 1px solid transparent;
            padding: 6px 12px;
            font-size: 16;
            line-height: 1.5;
            border-radius: 4px;
        }
        
        .btn:hover, .btn:focus {
            text-decoration: none;
        }
          
        .btn:focus, .btn.focus {
            outline: 0;
            box-shadow: none;
        }
          
        .btn.disabled, .btn:disabled {
            opacity: 0.65;
        }

        .edit-btn {
            color: var(--e-btn-col, #505050);
            background-color: var(--e-btn-bgc, #fff);
            border: 1px solid var(--e-btn-borc, #505050);
            font-size: var(--e-btn-fs, 14px);
            cursor: pointer;
        }
        
        .edit-btn:hover {
            color: var(--e-btn-col, #505050);
            background-color: var(--e-btn-bgc, #fff);
            border: 1px solid var(--e-btn-borc, #505050);
            font-size: var(--e-btn-fs, 14px);
            cursor: pointer;
        }
        
        .btn-success {
            color: var(--w-btn-col, #505050);
            background-color: var(--w-btn-bgc, #fff);
            border: 1px solid var(--w-btn-borc, #505050);
            font-size: var(--w-btn-fs, 14px);
            cursor: pointer;
        }
        
        .btn-success:hover {
            color: var(--w-btn-col, #fff);
            background-color: var(--w-btn-bgc, #505050);
            border: 1px solid var(--w-btn-borc, #505050);
            font-size: var(--w-btn-fs, 14px);
            cursor: pointer;
        }
        
        .btn-lg {
            padding: 8px 16px;
            font-size: var(--w-btn-fs, 14px);
            line-height: 1.5;
            border-radius: 4px;
        }
        
        .btn-block {
            display: block;
            width: 100%;
        }
        
        .error {
            font-size: var(--w-msg-fs, 13px);
            color: var(--w-msg-col, #000);
        }

        .error-text-color {
            color: var(--w-err-sys-col, red);
        }

        /* Element Style */
        .account-box {
            border-radius: 35px;
            position: relative;
            padding: 25px 25px;
            width: 100%;
            border: 1px solid var(--w-bg-borc, #505050);
            background-color: var(--w-bgc, #fff);
            box-sizing: border-box;
        }
        
        .accounnt-heading {
            font-size: var(--w-tit-fs, 14px);
            color: var(--w-tit-col, #000);
            background-color: var(--w-tit-bgc, #fff);
            padding: 10px;
            border-radius: 5px;
        }
        
        .editable-field {
            background-color: var(--editable-field-bgColor, transparent);
            border: 0px;
            color: var(--editable-field-color, #000000);
            font-size: 12px;
            font-weight: 600;
            pointer-events: none;
            text-overflow: ellipsis;
            visibility: hidden;
        }
        
        .editable-field.editonly {
            background-color: var(--editonly-bgColor, #FFF);
            border: 1px solid #D3D7D9;
            color: var(--editonly-color, #000000);
            border-radius: 3px;
            pointer-events: all;
            visibility: visible;
        }
        @media(max-width: 767px) {
            .account-box {
                padding: 15px;
                border-radius: 20px;
            }
        }
        `
    }

    render() {
        return html
            `<div class="account-box">
        <div class="text-center mg-b5">
            <h2 class="heading14 accounnt-heading">Your Account Number is ${this.getAccountNumber()}</h2>
        </div>
        <table class="table table-striped">
            <tbody>
                <tr>
                    <td><strong>Login</strong>: ${this.getSubscriberDetails("email")}</td>
                    <td>For change please call customer service</td>
                </tr>
                <tr>
                    <td><strong>Password</strong>: ${this.getSubscriberDetails("password")}</td>
                    <td>
                    <div class="edit-password">
                      ${this.editPassword ?
                html`<div class="form-group pd-rl2 mg-b5">
                        <input id="oldPassword" type="password" class=${classMap({ 'form-control': true, 'editable-field': true, 'editonly': this.editPassword })} placeholder="Existing Password">
                      </div>
                      <div id="updatePasswordDiv" class=${classMap({ 'form-group': true, 'pd-rl2': true, 'mg-b5': true, 'd-none': !this.editPassword })}>
                        <input id="updatePassword" type="password" class=${classMap({ 'form-control': true, 'editable-field': true, 'editonly': this.editPassword })} placeholder="New Password">
                      </div>
                      <div id="updateConfirmPasswordDiv" class=${classMap({ 'form-group': true, 'pd-rl2': true, 'mg-b5': true, 'd-none': !this.editPassword })}>
                         <input id="updateConfirmPassword" type="password" class=${classMap({ 'form-control': true, 'editable-field': true, 'editonly': this.editPassword })} placeholder="Confirm New Password">
                      </div>` :
                html`<button id="editPasswordButton" type="submit" class="btn edit-btn btn-lg btn-block" @click="${this.onEditPassword}">Change Password</button>`}
                        </div>
                    </td>
                </tr>
                <tr>
                    <td><strong>Name</strong>: ${this.getSubscriberDetails("firstName")} ${this.getSubscriberDetails("lastName")}</td>
                    <td>
                        <div class="first-lastNamebox">
                            ${this.editName ? html`<div class="form-group col-50 pd-rl2">
                                <input id="updateFirstName" type="text" class=${classMap({ 'form-control': true, 'editable-field': true, 'editonly': true })} placeholder="First Name">
                            </div>
                            <div class="form-group col-50 pd-rl2">
                                <input id="updateLastName" type="text" class=${classMap({ 'form-control': true, 'editable-field': true, 'editonly': true })} placeholder="Last Name">
                            </div>` :
                html`<p>For change please call customer service</p>`}
                        </div>
                    </td>
                </tr>
                <tr>
                    <td><strong>Address</strong>: ${this.getSubscriberDeliveryAddress()}</td>
                    <td>For change please call customer service</td>
                </tr>
                <tr>
                    <td><strong>Phone Number</strong>: ${this.getSubscriberDetails("phoneNumber")}</td>
                    <td>
                        <div>
                            ${this.editPhoneNumber ? html`<input id="updatePhoneNumber" maxlength="14" type="text" placeholder="XXX-XXX-XXXX" pattern="^(\([2-9]|[2-9])(\d{2}|\d{2}\))(-|.|\s)?\d{3}(-|.|\s)?\d{4}$" class=${classMap({ 'form-control': true, 'editable-field': true, 'editonly': true })}>` :
                html`<p>For change please call customer service</p>`}
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        ${this.editPhoneNumber || this.editName || this.editPassword ? html`<button id="cancelButton" type="submit" class="btn btn-success btn-lg btn-block mg-b5" @click="${this.cancelEdit}">Cancel</button>
        <div class=${classMap({ 'text-center': true, 'error': true, 'error-text-color': this.isSystemError })}>${this.accountDetailsErrorResponse}</div>
                   <button id="updateButton" type="submit" class="btn btn-success btn-lg btn-block" @click="${this.updateUserDetails}">Update</button>` :
                html``}
    </div>`
    }

    onEditPhoneNumber() {
        if (this.userDetails) {
            this.accountDetailsErrorResponse = '';
            this.isSystemError = false;
            this.edit = true;
            this.editPassword = false;
            this.editName = false;
            this.editPhoneNumber = true;
        }
    }

    onEditName() {
        if (this.userDetails) {
            this.accountDetailsErrorResponse = '';
            this.isSystemError = false;
            this.edit = true;
            this.editPassword = false;
            this.editPhoneNumber = false;
            this.editName = true;
        }
    }

    onEditPassword() {
        if (this.userDetails) {
            this.accountDetailsErrorResponse = '';
            this.isSystemError = false;
            this.edit = true;
            this.editName = false;
            this.editPhoneNumber = false;
            this.editPassword = true;
        }
    }

    cancelEdit() {
        if (this.editPhoneNumber) {
            this.editPhoneNumber = false;
        }

        if (this.editName) {
            this.editName = false;
        }

        if (this.editPassword) {
            this.editPassword = false;
        }
        this.edit = false;
        this.isSystemError = false;

        this.accountDetailsErrorResponse = '';
    }

    getSubscriberDetails(detailName) {
        let text = ''
        if (this.userDetails) {
            switch (detailName) {
                case "email":
                    text = this.userDetails.email;
                    break;
                case "password":
                    text = "********"
                    break;
                case "firstName":
                    text = this.userDetails.firstName;
                    break;
                case "lastName":
                    text = this.userDetails.lastName;
                    break;
                case "phoneNumber":
                    var match = this.userDetails.phoneNumber.replace(/\D/g, '').match(/^(\d{1,3})(\d{0,3})(\d{0,4})$/);
                    if (match) {
                        text = `${match[1] ? '(' : ''}${match[1]}${match[2] ? ') ' : ''}${match[2]}${match[3] ? '-' : ''}${match[3]}`;
                    }
                    break;
            }
        }
        return text;
    }

    getSubscriberDeliveryAddress() {
        if (this.deliveryAddress) {
            return `${this.deliveryAddress.address1}, ${this.deliveryAddress.city}, ${this.deliveryAddress.state}, ${this.deliveryAddress.country}, ${this.deliveryAddress.postalCode}`
        }
        return '';
    }

    async getSubscriberAddress() {
        try {
            const headers = {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': `Bearer ${this.loginDetails.token}`,
            }

            const response = await axios.get(`${this.MainServiceDomain}/appservices/api/v2/subscriber/${this.userDetails.subscriberId}/deliveryaddress`, {
                headers: headers
            });

            return response.data;

        } catch (error) {
            throw error;
        }
    }

    async onLogin(password) {
        try {
            const body = `grant_type=password&username=${encodeURIComponent(this.loginDetails.username)}&password=${encodeURIComponent(password)}`
            const headers = {
                'Content-Type': 'application/x-www-form-urlencoded',
            }

            const res = await axios.post(`${this.MainServiceDomain}/appservices/token`, body, {
                headers: headers
            });

            return res.data;
        } catch (error) {
            console.log(error.response);
            return error;
        }
    }

    async updatePassword(detail) {
        try {
            const loginResponse = await this.onLogin(detail.oldPassword);

            if (loginResponse.access_token) {
                this.loginDetails = Object.keys(loginResponse).map((key) => {
                    if (key === 'access_token') {
                        key = 'token';
                        return { [key]: loginResponse['access_token'] };
                    }
                    return { [key]: loginResponse[key] };
                }).reduce((a, b) => Object.assign({}, a, b));

                const headers = {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Authorization': `Bearer ${this.loginDetails.token}`,
                }

                const body = `NewPassword=${detail.newPassword}`
                const res = await axios.put(`${this.MainServiceDomain}/appservices/api/v2/account/password`, body, {
                    headers: headers,
                });

                return res;

            } else {
                return loginResponse;
            }

        } catch (error) {
            console.log(error)
            return error;
        }
    }

    async updateUserDetails() {
        try {
            const newPasswordField = this.shadowRoot.getElementById("updatePassword");
            const newConfirmPasswordField = this.shadowRoot.getElementById("updateConfirmPassword");
            const oldPasswordField = this.shadowRoot.getElementById("oldPassword");
            const newFirstNameField = this.shadowRoot.getElementById("updateFirstName");
            const newLastNameField = this.shadowRoot.getElementById("updateLastName");
            const newPhoneNumberField = this.shadowRoot.getElementById("updatePhoneNumber");
            this.accountDetailsErrorResponse = '';
            this.isSystemError = false;
            if (this.editPassword && oldPasswordField.value != '' && newPasswordField.value != '' && newConfirmPasswordField.value != '') {

                if (newPasswordField.value === newConfirmPasswordField.value) {
                    const detail = {
                        oldPassword: oldPasswordField.value,
                        newPassword: newPasswordField.value,
                    }
                    const res = await this.updatePassword(detail);
                    if (res.status === 204) {
                        this.editPassword = false;
                    } else if (res.response.data && res.response.data != '' && res.status != 500) {
                        if (res.response.data.error === "invalid_grant") {
                            this.accountDetailsErrorResponse = "incorrect old password";
                        } else {
                            this.accountDetailsErrorResponse = res.response.data.message;
                        }
                    } else {
                        this.isSystemError = true;
                        this.accountDetailsErrorResponse = "System is temporarily unavailable, please try again later";
                    }

                } else {
                    this.accountDetailsErrorResponse = "New passwords doesn't match";
                }

            } else if (this.editName && newLastNameField.value != '') {
                const detail = {
                    newFirstName: newFirstNameField.value,
                    newLastName: newLastNameField.value,
                    newPhoneNumber: this.userDetails.phoneNumber,
                }

                const res = await this.putSubscriberDetails(detail);
                if (res.status === 204) {
                    this.dispatchEvent(new CustomEvent('onUpdateAccountDetails', {
                        bubbles: true,
                        composed: true,
                    }));
                    this.editName = false;
                } else if (res.response.data && res.response.data != '' && res.response.data.message && res.status != 500) {
                    this.accountDetailsErrorResponse = res.response.data.message;
                } else {
                    this.isSystemError = true;
                    this.accountDetailsErrorResponse = "System is temporarily unavailable, please try again later";
                }

            } else if (this.editPhoneNumber && newPhoneNumberField.value != '') {
                if (newPhoneNumberField.value.match(/^\((\d{3})\)\s(\d{3})-(\d{4})$/)) {
                    const detail = {
                        newFirstName: this.userDetails.firstName,
                        newLastName: this.userDetails.lastName,
                        newPhoneNumber: newPhoneNumberField.value,
                    }

                    const res = await this.putSubscriberDetails(detail);
                    if (res.status === 204) {
                        this.dispatchEvent(new CustomEvent('onUpdateAccountDetails', {
                            bubbles: true,
                            composed: true,
                        }));
                        this.editPhoneNumber = false;
                    } else if (res.response.data && res.response.data != '' && res.response.data.message && res.status != 500) {
                        this.accountDetailsErrorResponse = res.response.data.message;
                    } else {
                        this.isSystemError = true;
                        this.accountDetailsErrorResponse = "System is temporarily unavailable, please try again later";
                    }

                } else {
                    this.accountDetailsErrorResponse = "Phone number should be in correct format (xxx) xxx-xxxx";
                }
            }
            else {
                this.accountDetailsErrorResponse = 'Field cannot be empty';
            }
        }
        catch (error) {
            this.accountDetailsErrorResponse = "Something went wrong";
        }
    }

    async putSubscriberDetails(detail) {
        try {

            const body = `FirstName=${detail.newFirstName}&LastName=${detail.newLastName}&PhoneNumber=${detail.newPhoneNumber}`;
            const headers = {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': `Bearer ${this.loginDetails.token}`,
            }

            const res = await axios.put(`${this.MainServiceDomain}/appservices/api/v2/subscriber/${this.userDetails.subscriberId}/profile`, body, {
                headers: headers,
            });

            return res;

        } catch (error) {
            console.log(error)
            return error;
        }
    }

    getAccountNumber() {
        if (this.subscriptionDetails) {
            if (this.subscriptionDetails.circulationDetails?.circSystemSubscriptionId) {
                return this.subscriptionDetails.circulationDetails.circSystemSubscriptionId;
            }
            return this.subscriptionDetails.subscriptionId;
        }
        return '';
    }
}

customElements.define('syncui-account-details', AccountDetailsComponent);